module.exports = __webpack_public_path__ + "static/media/logoemprega.cf8b2a4a.png";